//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import {Link} from 'react-router-dom'
import {FaFacebookF, FaTwitter, FaYoutube, FaLinkedinIn, FaInstagram, FaTiktok} from "react-icons/fa";
//@end

//@import components
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
import {routingService} from 'app_services/routingService'
// @end

// @INFO Import Styles
import './../footerPublicCommon.scss'

const footerImage = require('app_assets/images/logos/Campus_digital.svg')
const sicalLogo = require('app_assets/images/logos/logo_sical.png')
const efrLogo = require('app_assets/images/logos/efr.png')
const iqnetLogo = require('app_assets/images/logos/iq-net.png')
const iramLogo = require('app_assets/images/logos/iram-logo.png')

// @ADD Component types
interface IFooterPublicCommonLayoutProps {}

const FooterPublicCommonLayout: React.FC<IFooterPublicCommonLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <div className='footer_public-component'>
      <div className="container">

        <div className="footer-main">
          <div className="row section-1">
            <div className="col-6 links-related">
              <div className="link">
                <a href="https://www.icontec.org/contactenos/" target="_blank" rel="noreferrer">
                  Contáctanos
                </a>
              </div>
              <div className="link">
                <a href="https://www.elempleo.com/co/base-empresarial/icontec/1802" target="_blank" rel="noreferrer">
                  Trabaja con nosotros
                </a>
              </div>
              <div className="link">
                <a href="https://app.dataella.com/login" target="_blank" rel="noreferrer">
                  Afíliate
                </a>
              </div>
              <div className="link">
                <a href="https://www.icontec.org/nuestras-oficinas/" target="_blank" rel="noreferrer">
                  Nuestras oficinas
                </a>
              </div>
            </div>
            <div className="col-6 logo-campus">
              <img src={footerImage} alt="Logo Campus" />
            </div>
          </div>

          <div className="footer-public--politic-movil">
            <div className="divider"></div>
            <Link className='' to={routingService.getPublicPath()} style={{ fontWeight: 600, marginBottom: '-8px' }}>
              {t("modules.footer.copyright.politics")}
            </Link>

            <a href="https://www.icontec.org/terminos-y-condiciones/" target="_blank" rel="noreferrer" style={{ fontWeight: 600 }}>
              {t("modules.footer.copyright.terms_and_conditions")}
            </a>
            <span className="copyright-date desktop">
              {t("modules.footer.copyright.date", {date: moment().format('YYYY')})}
            </span>
          </div>

          <div className="row section-2">
            <div className="col-5 social-media">
              <div>
                Síguenos

                <div className="social-media-container">
                  <Link className='social-media-item' to={{pathname: 'https://www.linkedin.com/company/icontec-international/'}} target="_blank" rel="noopener noreferrer" >
                    <FaLinkedinIn size={25} />
                  </Link>
                  <Link className='social-media-item' to={{pathname: 'https://www.linkedin.com/company/icontec-international/'}} target="_blank" rel="noopener noreferrer" >
                    <FaInstagram size={25} />
                  </Link>
                  <Link className='social-media-item' to={{pathname: 'https://www.facebook.com/HuellaDeConfianza'}} target="_blank" rel="noopener noreferrer" >
                    <FaFacebookF size={25} />
                  </Link>
                  <Link className='social-media-item' to={{pathname: 'https://www.youtube.com/user/ICONTECinternacional'}} target="_blank" rel="noopener noreferrer" >
                    <FaYoutube size={25} />
                  </Link>
                  <Link className='social-media-item' to={{pathname: 'https://twitter.com/ICONTEC'}} target="_blank" rel="noopener noreferrer" >
                    <FaTwitter size={25} />
                  </Link>
                  <Link className='social-media-item' to={{pathname: 'https://twitter.com/ICONTEC'}} target="_blank" rel="noopener noreferrer" >
                    <FaTiktok size={25} />
                  </Link>
                </div>

              </div>
            </div>
            <div className="col-7 clients-related">
              <div className="client">
                <img src={iramLogo} alt="Logo Iram" style={{ width: '90px', height: '90px' }} />
              </div>
              <div className="client">
                <span>Subsistema Nacional de calidad</span>
                <img src={sicalLogo} alt="Logo Sical" />
              </div>
              <div className="client">
                <span>Miembro de la red IQNET</span>
                <img src={iqnetLogo} alt="Logo IQNET" />
              </div>
              <div className="client">
                <span>Empresa familiarmente responsable</span>
                <img src={efrLogo} alt="Logo Efr" />
              </div>
            </div>
          </div>
        </div>

        <div className="divider"></div>

        <div className="footer-public--movil-icons-section">
          <div className="footer-public--movil-logo">
            <img src={footerImage} alt="Logo Campus" />
          </div>
          <div className="footer-public--movil-icons">
            <img src={iramLogo} alt="Logo Iram" />
            <img src={sicalLogo} alt="Logo Sical" />
            <img src={iqnetLogo} alt="Logo IQNET" />
            <img src={efrLogo} alt="Logo Efr" />
          </div>
        </div>

        <div className="copyright">
          <span className="copyright-date desktop">
            {t("modules.footer.copyright.date", {date: moment().format('YYYY')})}
          </span>
          <div className="copyright-terms-and-conditions">
            <Link className='' to={routingService.getPublicPath()}>
              {t("modules.footer.copyright.politics")}
            </Link>

            <a href="https://www.icontec.org/terminos-y-condiciones/" target="_blank" rel="noreferrer">
              {t("modules.footer.copyright.terms_and_conditions")}
            </a>
          </div>
          <span className="copyright-date movil">
            {t("modules.footer.copyright.date", {date: moment().format('YYYY')})}
          </span>
        </div>
      </div>
    </div>
  )
}

export default FooterPublicCommonLayout
